import React, { useState, useEffect } from 'react'
import TextEditor from "./editor";
import { updateData } from "../../lib/taskm"

export default function TaskEdit({ value="", setValue, id,setStatus,status ,setUpdatedId}) {
//console.log("Taskedşt",value,id);
    const [newAnswer, setNewAnswer] = useState(value || '');
    const [show, setShow] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        //console.log("Answer", newAnswer);
        setValue(newAnswer);

        await updateData({
            id: id,
            desc: newAnswer
        });
        setStatus(!status);
        setShow(true);
        setUpdatedId(id);
    }

    useEffect(() => {
        if(value)
        setNewAnswer(value);
    }, [value])

    const messages = () => {
        return (<div className="alert alert-success alert-dismissible fade show" role="alert">
        <strong>Data Updated...</strong> {/*You should check in on some of those fields below.*/}
        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"
        onClick={e => setShow(false)}></button>
      </div>)
      }
      

    return (
        <form role="form" onSubmit={handleSubmit}>
            {show ? messages() : ""}
            <div className="col">
                <div className="form-group">

                    <div id="editor" >
                        <TextEditor value={newAnswer} setValue={setNewAnswer} />
                    </div>
                </div>
            </div>

            <div className="update-profile d-flex justify-content-between">
                <button type="submit" className="btn btn-primary">
                    Update
                </button>
            </div>
        </form>
    )
}
